<template>
  <div class="flex-shrink-0">
    <DocumentNotificationDialog :document="document">
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip v-bind="attrs" bottom v-on="on">
          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-btn
              v-bind="{ ...tooltipAttrs, ...attrs }"
              icon
              data-testid="btn-send-notification"
              v-on="{ ...on, ...tooltipOn }"
            >
              <v-icon medium>mdi-bell</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Send_notification') }}</span>
        </v-tooltip>
      </template>
    </DocumentNotificationDialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          icon
          data-testid="toggle-versions-sidebar"
          :aria-label="versionsSidebarTooltip"
          :aria-expanded="String(isVersionsSidebarExpanded)"
          v-on="on"
          @click="toggleVersionsSidebar"
        >
          <v-icon medium>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span data-testid="toggle-versions-sidebar-tooltip">{{ versionsSidebarTooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PSPDFKITActions',
  props: {
    document: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      getVersionsSidebar: 'application/getVersionsSidebar',
    }),
    isVersionsSidebarExpanded() {
      return this.$vuetify.breakpoint.mobile ? Boolean(this.getVersionsSidebar) : this.getVersionsSidebar !== false
    },
    versionsSidebarTooltip() {
      return this.$t(this.isVersionsSidebarExpanded ? 'Hide_versions' : 'Show_versions')
    },
  },
  methods: {
    ...mapActions({
      toggleVersionsSidebar: 'application/toggleVersionsSidebar',
    }),
  },
}
</script>
